import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row align-items-center" }
const _hoisted_2 = { class: "col-md-2" }
const _hoisted_3 = { class: "image-display" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "col-md-10" }
const _hoisted_8 = { class: "phone-number-input" }
const _hoisted_9 = ["placeholder", "disabled", "readonly"]

import { computed, toRefs, toRef, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'inputImage',
  props: {
    pathImage: {
        type: String,
        default: '',
    },
    modelValue: {
        type: String,
        default: '',
    },
    label: String,
    placeholder: {
        type: String,
        default: 'Enter phone number',
    },
    disabled: Boolean,
    readonly: Boolean,
    v: {
        type: Object,
    },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emits = __emit;

const isBase64 = computed(() => {
    // Check if modelValue is a base64 string
    return /^data:image\/[a-zA-Z]*;base64,/.test(props.modelValue);
});

const isFilePath = computed(() => {
    // Check if modelValue is a file path (assuming it's not a base64 string)
    return !isBase64.value && props.modelValue !== '';
});

const getImageUrl = (path: string) => {
    // Assuming the path is relative or absolute on the server
    return process.env.VUE_APP_URL + path; // Adjust as per your server setup
};
const getDefaultImage = () => {
    return process.env.VUE_APP_DEFAULT_IMAGE
};

// Use ref to make path_image reactive
let path_image = ref<string | null>(null);
let { pathImage } = toRefs(props);

watch(
    () => pathImage.value,
    (newValue) => {
        // Update the reactive path_image with the new value or null
        path_image.value = newValue ?? null;
    }
);

//let path_image = ref<string | null>(null);
let fileInputRef = ref<HTMLInputElement | null>(null);

const handleFileInputChange = (event: Event) => {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
            const base64String = e.target?.result as string;
            // Emit the base64 string to parent component
            emits('update:modelValue', base64String);
            path_image.value = base64String
        };
        reader.readAsDataURL(file);
    }
};

const deleteImage = () => {
    path_image.value = null
    emits('update:modelValue', path_image);
    // Clear the file input
    if (fileInputRef.value) {
        fileInputRef.value.value = '';  // Reset the file input value
    }
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        ((isBase64.value && _unref(path_image)) || (isFilePath.value && _unref(path_image)))
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "delete-img",
              onClick: deleteImage
            }, " X "))
          : _createCommentVNode("", true),
        (isBase64.value && _unref(path_image))
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: _unref(path_image),
              alt: "Uploaded Image"
            }, null, 8, _hoisted_4))
          : (isFilePath.value && _unref(path_image))
            ? (_openBlock(), _createElementBlock("img", {
                key: 2,
                src: getImageUrl(_unref(path_image)),
                alt: "Uploaded Image"
              }, null, 8, _hoisted_5))
            : (_openBlock(), _createElementBlock("img", {
                key: 3,
                src: getDefaultImage(),
                alt: "Uploaded Image"
              }, null, 8, _hoisted_6))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("input", {
          type: "file",
          accept: "image/*",
          onChange: handleFileInputChange,
          placeholder: __props.placeholder,
          disabled: __props.disabled,
          readonly: __props.readonly,
          class: "form-control",
          ref_key: "fileInputRef",
          ref: fileInputRef
        }, null, 40, _hoisted_9),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.v?.$errors, (error) => {
          return (_openBlock(), _createElementBlock("span", {
            class: "text-danger mt-3",
            key: error.$uid
          }, [
            _createTextVNode(" - " + _toDisplayString(error.$message) + " ", 1),
            _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1))
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})